// src/components/Footer.js
import React from "react";
import { Link } from "react-router-dom";
import "../styles/Footer.css";
import facebookIcon from "../assets/icons/Facebook_Icon.png";
import xIcon from "../assets/icons/X_Icon.png";
import instagramIcon from "../assets/icons/Instagram_Icon.png";

// import Toastify
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Footer = () => {
  const handleInstagramClick = () => {
    navigator.clipboard.writeText("https://holidaylights.tamarac.gov/register");
    toast.success("Link copied! You can now paste it into Instagram.", {
      position: "bottom-center",
      autoClose: 2000,
    });
  };

  return (
    <footer className="footer">
      {/* Center section */}
      <div className="footer-center">
        <h2>Share the Contest</h2>
        <div className="share-buttons">
          {/* Facebook */}
          <a
            href="https://www.facebook.com/sharer/sharer.php?u=https://holidaylights.tamarac.gov/register"
            target="_blank"
            rel="noopener noreferrer"
            className="icon-btn"
          >
            <img src={facebookIcon} alt="Facebook" />
          </a>

          {/* Twitter / X */}
          <a
            href="https://twitter.com/intent/tweet?url=https://holidaylights.tamarac.gov/register&text=Join%20Tamarac's%20Holiday%20Lights%20Contest!"
            target="_blank"
            rel="noopener noreferrer"
            className="icon-btn"
          >
            <img src={xIcon} alt="Twitter" />
          </a>

          {/* Instagram (copy link + toast) */}
          <button className="icon-btn" onClick={handleInstagramClick}>
            <img src={instagramIcon} alt="Instagram" />
          </button>
        </div>
      </div>

      {/* Bottom row: left + right */}
      <div className="footer-bottom">
        <div className="footer-left">
          <p>© 2025 Tamarac Holiday Lights Contest. All rights reserved.</p>
        </div>
        <div className="footer-right">
          <nav className="footer-links">
            <Link to="https://www.tamarac.gov/TermsOfUse" className="footer-link">
              Terms of Use
            </Link>
            <span className="divider">|</span>
            <Link to="https://www.tamarac.gov/PrivacyPolicy" className="footer-link">
              Privacy Policy
            </Link>
          </nav>
        </div>
      </div>

      {/* Toast container */}
      <ToastContainer />
    </footer>
  );
};

export default Footer;



